import type { NodeParamBase } from '../types/NodeParamBase';

export const nodeParamsEqual = (left: NodeParamBase, right: NodeParamBase): boolean =>
  left.isArray === right.isArray && left.type === right.type;
